var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 50,
    viewBox: "0 0 37 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9665 18.834L26.2999 17.134V6.46729H10.1665V17.234L12.3998 18.834C13.6665 17.0006 15.7998 15.8006 18.1998 15.8006C20.5998 15.8006 22.6999 17.0006 23.9665 18.834Z",
    fill: "#E60000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.7328L18.1667 23.0328L21.4 20.6995C20.7 19.6662 19.5333 18.9995 18.2 18.9995C16.8667 19.0328 15.6667 19.6995 15 20.7328Z",
    fill: "#E60000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93291 6.26668C6.93291 4.56667 8.29958 3.2 9.99959 3.2H26.4329C28.1329 3.2 29.4996 4.56667 29.4996 6.26668V14.8334L32.6996 12.5333V6.26668C32.6996 6.23334 32.6996 6.23334 32.6996 6.20001V3.13334V0.233335V0H26.4996H26.4663H10.0329H9.99959H3.73291V0.233335V3.13334V6.20001C3.73291 6.23334 3.73291 6.23334 3.73291 6.26668V12.5333L6.93291 14.8667V6.26668Z",
    fill: "#E60000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.7671V35.6004L18.2334 50.0005L36.4667 35.6004V13.7671C30.3667 18.1671 24.2667 22.5671 18.1667 26.9671C12.1 22.5671 6.03334 18.1671 0 13.7671Z",
    fill: "#E60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7a66ee91cb78e14aeb48682a191f8307.svg";
export { ForwardRef as ReactComponent };